/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnteResDto } from '../../models/ente-res-dto';

export interface EntiControllerDeleteEnte$Params {
  idEnte: number;
}

export function entiControllerDeleteEnte(
  http: HttpClient,
  rootUrl: string,
  params: EntiControllerDeleteEnte$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<EnteResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    entiControllerDeleteEnte.PATH,
    'delete',
  );
  if (params) {
    rb.path('idEnte', params.idEnte, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnteResDto>;
      }),
    );
}

entiControllerDeleteEnte.PATH = '/admin/ente/id/{idEnte}';
